<template>
  <div>
    <a-modal
      title="提交大众裁判"
      :visible="visible"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>注：请填写真实的名称与手机号码，提交的数据，后台将会审核，审核通过的才可成为大众裁判！</p>
      <a-form :form="form" class="form" style="margin-top: 10px;">
        <a-form-item :required="true" :labelCol="labelCol" :wrapperCol="wrapperCol" label="裁判头像" style="margin-bottom: 20px;">
          <div style="height: 104px;overflow: hidden;">
            <upload ref="upload" :length="1" :imgs="imgs" @uploadSuccess="uploadSuccess" :cutImg="true" uploadTest="点击上传" :fixedNumber="[5,7]"></upload>
          </div>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="裁判名称">
          <a-input placeholder="请输入裁判名称" v-decorator="['name', { rules: [{required: true, message: '请输入裁判名称'}]}]"/>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号码">
          <a-input placeholder="请输入手机号码" v-decorator="['mobile', { rules: [{required: true, message: '请输入账号（手机号码）'}]}]"/>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="裁判等级">
          <a-select v-decorator="['grade',{ rules: [{ required: true, message: '请选择裁判等级!' }]}]" placeholder="请选择裁判等级">
            <a-select-option value="国家A级裁判">
              国家A级裁判
            </a-select-option>
            <a-select-option value="国家级裁判">
              国家级裁判
            </a-select-option>
            <a-select-option value="一级裁判">
              一级裁判
            </a-select-option>
            <a-select-option value="二级裁判">
              二级裁判
            </a-select-option>
            <a-select-option value="三级裁判">
              三级裁判
            </a-select-option>
            <a-select-option value="普通裁判">
              普通裁判
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="裁判简介">
          <a-textarea
            v-model="introduction"
            placeholder="请输入裁判简介"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import Upload from '@comm/upload/Upload'
import matchFun from '@comm/utils/matchFun'
import { mapState } from 'vuex'
export default {
  components: {
    Upload
  },
  data () {
    return {
      visible: false,
      confirmLoading: false,
      matchFun: matchFun,
      imgs: [],
      introduction: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  methods: {
    show () {
      this.visible = true
    },
    handleOk (e) {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          var upData = {...values}
          if (this.imgs && this.imgs.length > 0) {
            upData.image = this.imgs[0].url
          } else {
            this.$message.warn('请上传头像')
            return
          }
          if (!this.matchFun.phoneFun(upData.mobile)) {
            this.$message.error('请输入正确的手机号码')
            return
          }
          upData.agencyId = Number(this.$route.query.agencyId)
          upData.matchId = this.$route.query.matchId
          upData.introduction = this.introduction
          this.$api.match.onlinePublic(upData).then(res => {
            if (res.status === 0) {
              this.$message.success('提交成功')
              this.handleCancel()
            } else {
              this.$message.warn(res.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },
    handleCancel (e) {
      this.visible = false
    },
    uploadSuccess (e) {
      this.imgs = e
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comm/components/join/heaveCompetition/OnlinePublic.vue